import { ThreeApp } from "../work-modules/006/bln";

window.addEventListener(
  "DOMContentLoaded",
  async () => {
    const canvas: HTMLCanvasElement | null = document.querySelector("#balloonCanvas");
    if (!canvas) {
      console.error("canvas not found");
      return;
    }
    const app = new ThreeApp(canvas);

    // ローディング表示を初期化
    app.initLoading();

    // レンダラーとシーンの基本設定を初期化
    app.initRenderer();

    // アセットを読み込み（この中でシーンの初期化も行われる）
    await app.load();

    // レンダリング開始
    app.render();
  },
  false
);
